"use client";

import { getAuthToken } from "@dynamic-labs/sdk-react-core";
import {
  useMutation,
  type UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";

import { useAccount } from "#/store/wallet/account/account";

import type { Referral } from "../../firebase/firebase.types";
import { createReferral } from "../referrals.service";

export const useCreateReferral = (
  options?: UseMutationOptions<Referral, Error>,
) => {
  const queryClient = useQueryClient();
  const { account } = useAccount();

  return useMutation({
    ...options,
    mutationFn: async () => {
      const token = getAuthToken();
      if (!token) {
        throw new Error("Authorization token not available");
      }
      return createReferral({ token });
    },
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ["fetchReferralsByAccount", account],
      });
      options?.onSuccess?.(...args);
    },
  });
};
